module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100 align-items-center"
  }, [_c('div', {
    staticClass: "col-md-3 px-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-right"
  }, [_c('button', {
    staticClass: "btn tertiary px-5",
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a434527c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions/footerButtons.vue
// module id = 1892
// module chunks = 0